// extracted by mini-css-extract-plugin
export default {"lineButtons":"otherPropertyItemNew_lineButtons__Mm-yb","headers":"otherPropertyItemNew_headers__dz2MD","semiTitle":"otherPropertyItemNew_semiTitle__KFimD"};